import React from 'react'
import { Flex, Box } from 'reflexbox'

export const Container = (props: any) => <Box {...props} />

Container.defaultProps = {
  paddingX: [4, null, null, 6],
  width: 1,
}

export const Row = (props: any) => <Flex {...props} />

Row.defaultProps = {
  marginX: ['-4px', null, null, '-12px'],
  flexDirection: ['column', null, null, 'row'],
  flexWrap: 'wrap',
}

export const Column = (props: any) => <Box {...props} />

Column.defaultProps = {
  position: 'realtive',
  width: '100%',
  minHeight: '1px',
  paddingX: [1, null, null, 3],
}
